import { render } from "solid-js/web";
import { App } from "./App.tsx";
import "./styles/globals.scss";

const root = document.getElementById("root");
if (root === null) throw new Error("Missing #root element");

render(() => <App />, root);
